import { P as h, A as m, b as c, n as o, t as u } from "./element-CV9utnHJ.js";
import { P } from "./pkt-slot-controller-D7CrjM52.js";
import { e as k, n as g } from "./ref-Dma3n3i8.js";
import { e as y } from "./class-map-3ADKve8g.js";
import "./icon-D0IQAVwS.js";
const d = { href: { default: "#" }, target: { default: "_self" } }, f = {
  props: d
};
var _ = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, r = (i, n, l, s) => {
  for (var t = s > 1 ? void 0 : s ? $(n, l) : n, p = i.length - 1, a; p >= 0; p--)
    (a = i[p]) && (t = (s ? a(n, l, t) : a(t)) || t);
  return s && t && _(n, l, t), t;
};
let e = class extends h {
  constructor() {
    super(), this.defaultSlot = k(), this.href = f.props.href.default, this.iconName = void 0, this.iconPosition = void 0, this.external = !1, this.target = f.props.target.default, this.slotController = new P(this, this.defaultSlot);
  }
  render() {
    const i = {
      "pkt-link": !0,
      "pkt-link--icon-left": !!this.iconName && this.iconPosition === "left" || !!(this.iconName && !this.iconPosition),
      "pkt-link--icon-right": !!this.iconName && this.iconPosition === "right",
      "pkt-link--external": this.external
    };
    return c`<a
      class=${y(i)}
      href=${this.href}
      .target=${this.target}
      .rel=${this.external ? "noopener noreferrer" : m}
      >${this.iconName ? c`<pkt-icon name=${this.iconName} class="pkt-link__icon"></pkt-icon>` : ""} <span ${g(this.defaultSlot)}>Link</span></a
    >`;
  }
};
r([
  o({ type: String, reflect: !0 })
], e.prototype, "href", 2);
r([
  o({ type: String, reflect: !0 })
], e.prototype, "iconName", 2);
r([
  o({ type: String, reflect: !0 })
], e.prototype, "iconPosition", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "external", 2);
r([
  o({ type: String, reflect: !0 })
], e.prototype, "target", 2);
e = r([
  u("pkt-link")
], e);
export {
  e as P
};
